import React from 'react';
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout';
import strings from "../../components/Language";
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { getToken, storeUserData } from './../../components/Util';
import "./orders.scss";
import LoaderContext from '../../components/Loader/LoaderContext.js';
import SwipeableViews from 'react-swipeable-views';
import DCAOrders from './DCAOrders.js';
import BOLLOrders from './BOLLOrders.js';
import AIOrders from './AIOrders.js';
import SubLayout from '../../components/Layout/SubLayout.js';

class OrdersScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		var tab_name = this.props.match.params.tab_name;
		var tabValue = 0;
		if (tab_name == 'DCA') {
			tabValue = 0;
		} else if (tab_name == 'CTS') {
			tabValue = 1;
		} else if (tab_name == 'AI') {
			tabValue = 2;
		}
		this.state = {
			access_token: "",
			tabValue: tabValue,
			is_dca_logs: true,
			is_boll_logs: false,
			is_ai_logs: false,
			balance: 0,
		}
		this.handleChange = this.handleChange.bind(this);

	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				this.setState({ access_token: token });
			});
		}
	}

	handleChange(event, newValue) {
		const self = this;
		if (newValue == "DCABot") {
			self.setState({
				is_dca_logs: true,
				is_boll_logs: false,
				is_ai_logs: false,
			})
		} else if (newValue == "AIBot") {
			self.setState({
				is_dca_logs: true,
				is_boll_logs: false,
				is_ai_logs: true,
			})
		} else {
			self.setState({
				is_dca_logs: false,
				is_boll_logs: true,
				is_ai_logs: false,
			})
		}
		self.setState({ tabValue: newValue });
	};

	render() {

		return (
			<>
				<SubLayout data={{ "title": strings.logs }}>

					<div className="" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
						<Tabs
							value={this.state.tabValue}
							onChange={this.handleChange}
							variant="fullWidth"
							aria-label=""
						>
							<Tab label="DCA" />
							<Tab label="CTS" />
							<Tab label="AI" />
						</Tabs>
					</div>
					<SwipeableViews index={this.state.tabValue} onChangeIndex={(index) => this.setState({ tabValue: index })} style={{ minHeight: "calc(50vh - 190px)", paddingBottom: 50 }}>
						<div role="tabpanel" hidden={this.state.tabValue !== 0}>
							{this.state.tabValue === 0 ?
								<div className="">
									<DCAOrders />
								</div>
								: null}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 1}>
							{this.state.tabValue === 1 ?
								<div className="">
									<BOLLOrders />
								</div>
								: null}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 2}>
							{this.state.tabValue === 2 ?
								<div className="">
									<AIOrders />
								</div>
								: null}
						</div>
					</SwipeableViews>
				</SubLayout>
			</>
		);
	}
}

export default OrdersScreen;